import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePickerSelection } from '../../../_gestor/contenidos.types';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { FormBuilder } from '@angular/forms';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent extends ComponentBase implements OnInit {
    @Input() fechaInicio: Date;
    @Input() fechaFin: Date;
    @Input() display = false;
    @Output() accept = new EventEmitter<DatePickerSelection>();

    title = 'Elige el rango de fechas para la búsqueda';

    rangeDates: Date[];

    constructor(
        private fb: FormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.createForm();
    }

    /**
     * Instanciate the form and initialize the default values.
     */
    private createForm(): void {
        this.rangeDates = [this.fechaInicio, this.fechaFin];
        this.form = this.fb.group({
            rangeDates: this.rangeDates,
        });
    }

    acceptDialog($event: any): void {
        $event.stopPropagation();
        const selection = new DatePickerSelection();
        if (this.form.value.rangeDates && this.form.value.rangeDates.length > 0) {
            selection.fechaInicio = this.form.value.rangeDates[0];
            selection.fechaFin = this.form.value.rangeDates[1];
        }
        this.accept.emit(selection);
        this.closeDialog();
    }

    cancelDialog($event: any): void {
        $event?.stopPropagation();
        this.closeDialog();
    }

    showDialog(): void {
        this.display = true;
    }

    closeDialog(): void {
        this.display = false;
    }

    /**
     * Para controlar la propiedad disabled del botón de reset.
     * @returns boolean
     */
    get formIsUntouched(): boolean {
        return this.form.pristine || !this.form.dirty || !this.form.value.rangeDates;
    }
}
